// extracted by mini-css-extract-plugin
export default {"primary":"button_primary__ZKyxA","secondary":"button_secondary__BW4TH"};